import { render, staticRenderFns } from "./StringWidget.vue?vue&type=template&id=0abe734e&scoped=true&"
import script from "./StringWidget.vue?vue&type=script&lang=js&"
export * from "./StringWidget.vue?vue&type=script&lang=js&"
import style0 from "./StringWidget.vue?vue&type=style&index=0&id=0abe734e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abe734e",
  null
  
)

export default component.exports